import { Ref, forwardRef } from 'react';
import PhoneInput, { PhoneInputProps } from 'react-phone-input-2';
import pt from 'react-phone-input-2/lang/pt.json';
import 'react-phone-input-2/lib/material.css';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from '../../modules/translation/TranslationContext';

type PhoneFieldProps = PhoneInputProps & {
  inputRef: Ref<unknown> | undefined;
};

const useStyles = makeStyles()(() => ({
  container: {
    position: 'relative',
    width: '100% !important',
    paddingRight: '8px !important',
    '& input:focus': {
      boxShadow: `none !important`,
    },
  },
  input: {
    border: 'inherit !important',
    paddingTop: '0px !important',
    paddingBottom: '0px !important',
    paddingRight: '0px !important',
    paddingLeft: '40px !important',
    width: 'inherit !important',
    fontSize: '14px !important',
  },
  button: {
    position: 'absolute',
    borderTop: 'none !important',
    top: 0,
    bottom: 0,
    '& > .selected-flag': {
      padding: '0px !important',
      maxWidth: '41px',
    },
  },
}));

const PhoneField = forwardRef((props: PhoneFieldProps, ref) => {
  const { isPortuguese } = useTranslation();
  const localization = isPortuguese ? pt : undefined;
  const { classes } = useStyles();

  return (
    <PhoneInput
      specialLabel=""
      // TODO: TEM UM PROBLEMA DE TIPAGEM AQUI, MAS A REF APARENTEMENTE FUNCIONA - VERIFICAR DEPOIS
      ref={ref}
      {...props}
      country="br"
      localization={localization}
      inputClass={classes.input}
      buttonClass={classes.button}
      containerClass={classes.container}
      placeholder={isPortuguese ? '+55 (00) 00000000' : undefined}
      copyNumbersOnly
    />
  );
});

export default PhoneField;
